import React, { useState, useEffect } from 'react';
import Container from '@mui/material/Container';
import { Typography, Grid, Box } from '@mui/material';
import HeadingContainer from '../heading-container/HeadingContainer';
import './methodology.css';

function Methodology() {
  const [methodsData, setMethodsData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_BASE_URI}/secure/admin/get/methodology`)
      .then(res => res.json())
      .then(data => {
        if (data && Array.isArray(data)) {
          // Sort by sortOrder if available
          const sorted = data.sort((a, b) => (a.sortOrder || 0) - (b.sortOrder || 0));
          setMethodsData(sorted);
        }
        setLoading(false);
      })
      .catch(err => {
        console.error("Error fetching methodology data", err);
        setLoading(false);
      });
  }, []);

  const displayMethods = methodsData;

  // Icons and colors to circle through if they are dynamic
  const presetIcons = ["🎲", "🌱", "🎨", "⭐", "📚", "🔬", "🌈", "🎈"];
  const presetColors = ["#FF9A9E", "#A1C4FD", "#FBC2EB", "#84FAB0", "#FDD181", "#D4FC79", "#E0C3FC", "#C2E9FB"];

  return (
    <div style={{ backgroundColor: '#fcfcfc', minHeight: '80vh', paddingBottom: '60px' }}>
      <HeadingContainer title="Our Methodology" />
      <Container maxWidth="lg" sx={{ mt: 6 }}>
        <Typography variant="body1" sx={{ textAlign: 'center', mb: 6, color: '#64748b', fontSize: '1.2rem', maxWidth: '800px', mx: 'auto' }}>
          We are dedicated to providing a comprehensive and holistic educational experience. This modern methodology ensures that children develop necessary skills while fostering a lifelong love for learning.
        </Typography>

        {loading ? (
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
              <div className="spinner" style={{ border: '4px solid rgba(0,0,0,0.1)', width: '36px', height: '36px', borderRadius: '50%', borderLeftColor: 'var(--primary)', animation: 'spin 1s linear infinite' }}></div>
              <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
          </div>
        ) : (
          <Grid container spacing={4}>
            {displayMethods.map((m, idx) => {
              const icon = m.iconUrl ? <img src={m.iconUrl} alt="icon" style={{width: '60px', height: '60px', objectFit: 'contain'}} /> : m.icon || presetIcons[idx % presetIcons.length];
              const color = m.color || presetColors[idx % presetColors.length];
              const isArray = Array.isArray(m.keyPoints);

              return (
                <Grid item xs={12} sm={6} md={4} key={m._id || idx}>
                  <Box className="method-card hover-scale" sx={{ 
                      height: '100%', 
                      p: 4, 
                      borderRadius: '24px', 
                      backgroundColor: 'white',
                      boxShadow: '0 10px 30px rgba(0,0,0,0.03)',
                      borderTop: `6px solid ${color}`,
                      position: 'relative',
                      overflow: 'hidden'
                    }}>
                    <div style={{ fontSize: '3rem', marginBottom: '15px' }}>{icon}</div>
                    <Typography variant="h6" sx={{ fontWeight: 700, mb: 2, fontFamily: 'var(--font-heading)', color: 'var(--text-main)' }}>
                      {m.title}
                    </Typography>
                    <div style={{ color: '#64748b', lineHeight: 1.7, whiteSpace: 'pre-line', fontSize: '0.875rem' }}>
                      {isArray && m.keyPoints.length > 0 ? (
                        <ul style={{ paddingLeft: '20px', margin: 0 }}>
                          {m.keyPoints.map((pt, i) => <li key={i} style={{marginBottom: '4px'}}>{pt}</li>)}
                        </ul>
                      ) : m.description}
                    </div>
                  </Box>
                </Grid>
              );
            })}
          </Grid>
        )}
      </Container>
    </div>
  );
}

export default Methodology;
